<template>
  <div class="addquestion">
    <div class="choseType" v-if="!editType">
      <el-button :class="{ active: type == 1 }" @click="choseType(1)">单选题</el-button>
      <el-button :class="{ active: type == 2 }" @click="choseType(2)">多选题</el-button>
      <el-button :class="{ active: type == 3 }" @click="choseType(3)">判断题</el-button>
      <el-button :class="{ active: type == 4 }" @click="choseType(4)">填空题</el-button>
    </div>
    <br />

    <div v-show="ques">
      <div class="queTitle" v-show="form.name">
        <div v-html="form.name"></div>
      </div>

      <p class="item_option" v-for="(option, index) in form.options" :key="index">
        <span><span v-show="type != 4"> {{ arr[index] }}:</span>{{ option.name }}</span>
      </p>
    </div>
    <el-form class="optionForm" ref="form" :model="form" label-width="130px" label-position="left">
      <el-form-item label="题干：">
        <!-- <el-input size="mini" v-model="form.name" placeholder="请输入题目"></el-input> -->
        <quill-editor v-model="form.name" class="ql-editor" :options="editorOption" ref="myQuillEditor"></quill-editor>

        <el-upload class="editorUploader" action="/" :show-file-list="false" :before-upload="beforeUpload"
          accept=".png,.jpg">
          <el-button class="el-icon-plus avatar-uploader-icon uploadBtn"></el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="匹配方式：" v-if="type == 4">
        <el-radio v-model="form.fit" @change="$forceUpdate()" label="0">模糊匹配</el-radio>
        <el-radio v-model="form.fit" @change="$forceUpdate()" label="1">精确匹配</el-radio>
      </el-form-item>
      <el-form-item label="答案解析：">
        <el-input size="mini" type="textarea" v-model="form.parsing"></el-input>
      </el-form-item>
      <el-form-item label="难易程度：">
        <el-select v-model="form.difficulty" clearable placeholder="请选择">
          <el-option v-for="item in difficulty" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择科目和章节：">
        <el-cascader :options="chapter" clearable v-model="form.chapter_id" @change="handleChange"></el-cascader>
      </el-form-item>
      <el-form-item label="关键字：">
        <el-input size="mini" v-model="form.keyword"></el-input>
      </el-form-item>

      <el-form-item v-if="!database && editType" label="是否在题库：">
        <el-switch disabled v-model="form.is_bank"></el-switch>
      </el-form-item>
      <el-form-item v-if="!database" label="插入到题库：">
        <el-switch v-model="form.is_insert" @change="handleInsert"></el-switch>
      </el-form-item>

      <el-form-item v-if="!database && editType && form.is_bank" label="同步更新到题库：">
        <el-switch @change="handleSync" v-model="form.is_sync"></el-switch>
      </el-form-item>
    </el-form>
    <div class="options">
      <el-row :gutter="20">
        <el-col :span="12">选项文字</el-col>
        <el-col :span="4">说明</el-col>
        <el-col :span="4" v-if="type != 4">正确答案</el-col>
        <el-col :span="4" v-if="type !== 3">编辑</el-col>
      </el-row>
      <el-row v-for="(option, index) in form.options" :key="index" :gutter="20">
        <!--题目  -->
        <el-col :span="12">
          <el-input v-if="type !== 3" size="mini" v-focus="optionIndex" v-model="option.name"></el-input>
          <el-input v-else :disabled="true" size="mini" v-model="option.name"></el-input>
        </el-col>
        <!-- 说明 -->
        <el-col :span="4">
          <!-- <el-button @click="setDesc(option.desc)" icon="el-icon-document"></el-button> -->
          <el-input size="mini" v-model="option.brief"></el-input>
        </el-col>
        <!-- 填空 -->
        <el-col v-if="type == 4" :span="4"> </el-col>
        <!-- 单选 -->
        <el-col v-else-if="type !== 2" :span="4">
          <el-radio v-model="form.is_right" @change="
              (val) => {
                fun(val, option);
              }
            " :label="index">
            <i></i>
          </el-radio>
        </el-col>
        <!-- 多选 -->
        <el-col v-else :span="4">
          <el-checkbox v-model="form.is_right" @change="
              (val) => {
                fun(val, option);
              }
            " :label="index">
            <i></i>
          </el-checkbox>
        </el-col>

        <el-col v-if="type !== 3" :span="4">
          <el-button size="mini" @click.prevent="removeOption(index, option.id)">删除</el-button>
        </el-col>
      </el-row>
      <p class="addOption" v-if="type !== 3">
        <i class="el-icon-circle-plus-outline"></i>
        <span @click="addOption">添加选项</span>
      </p>
    </div>
    <p class="submint-btn">
      <el-button type="primary" @click="onSubmit" v-if="!ques">立即创建</el-button>
      <el-button type="primary" @click="onSubmit" v-else>保存修改</el-button>
    </p>
    <el-dialog title="编辑" :visible.sync="showDesc" width="30%">
      <Brief :brief="brief"></Brief>
    </el-dialog>
  </div>
</template>
<script>
  import Brief from "./Brief";
  import * as qiniu from "qiniu-js";
  import "quill/dist/quill.core.css";
  import "quill/dist/quill.snow.css";
  import "quill/dist/quill.bubble.css";
  import { Quill, quillEditor } from "vue-quill-editor";
  import quillConfig from "../../../assets/js/quill-config";

  export default {
    name: "AddQuestion",
    components: { Brief, quillEditor },
    data() {
      return {
        CoverputExtra: {
          mimeType: ["image/png", "image/jpg", "image/jpeg"],
        },
        config: {
          useCdnDomain: true,
        },
        ext: "",
        percent: 0,
        fullscreenLoading: false,
        token: "",
        imageUrl: "",
        brief: "",
        showDesc: false,
        form: {},
        difficulty: ["A", "B", "C", "D", "E"],
        arr: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
        chapter: [],
        type: 1,
        optionIndex: null, //新增加选项的索引
        editorOption: quillConfig,
      };
    },
    props: ["editType", "ques", "database"],
    watch: {
      type: function () {
        this.change();
      },
      ques: function () {
        this.init();
      },
      editType: function () {
        this.init();
      },
    },
    created() {
      this.init();
      this.qiniuToken();
    },
    mounted() {
      quillConfig.register(Quill);
      quillConfig.initButton();
    },
    methods: {
      qiniuToken() {
        let _this = this;
        this.$http
          .get(process.env.VUE_APP_URL + "qiniuToken")
          .then(function (data) {
            if (data.data.code == 200) {
              if (data.data.msg) {
                _this.token = data.data.msg.uptoken;
              }
            }
          })
          .catch(function (error) {
            _this.$message.error({ message: "网络错误,请刷新界面重试" });
            return;
          });
      },
      change() {
        let id = this.$route.params.id;
        if (!this.ques) {
          //如果是新增题目
          this.form.paper_id = id;
          this.form.type = this.type;

          this.form.is_insert = true;
          this.form.options = [
            {
              //选项
              name: "",
              brief: "",
              is_right: false,
            },
            {
              name: "",
              brief: "",
              is_right: false,
            },
            {
              //选项
              name: "",
              brief: "",
              is_right: false,
            },
            {
              name: "",
              brief: "",
              is_right: false,
            },
          ];

          if (this.type == 2) {
            this.form.is_right = [];
          }
          if (this.type == 3) {
            this.form.options = this.form.options.slice(0, 2);
            this.form.options[0].name = "是";
            this.form.options[1].name = "否";
          }
          if (this.type == 4) {
            this.form.fit = "0";
          }
        }
      },
      init() {
        let id = this.$route.params.id,
          _this = this;
        if (!this.ques) {
          //如果是新增题目
          this.form = {
            paper_id: id,
            is_right: null,
            type: this.type,
            name: "",
            parsing: "", //答案解析
            difficulty: "",
            keyword: "",
            chapter_id: "",
            is_insert: true,
            options: [
              {
                //选项
                name: "",
                brief: "",
                is_right: false,
              },
              {
                name: "",
                brief: "",
                is_right: false,
              },
              {
                //选项
                name: "",
                brief: "",
                is_right: false,
              },
              {
                name: "",
                brief: "",
                is_right: false,
              },
            ],
          };
          if (this.type == 2) {
            this.form.is_right = [];
          }

          if (this.type == 3) {
            this.form.options = this.form.options.slice(0, 2);
            this.form.options[0].name = "是";
            this.form.options[1].name = "否";
          }
          if (this.type == 4) {
            this.form.fit = "0";
          }
        } else {
          this.type = this.editType;
          this.form = JSON.parse(JSON.stringify(this.ques));
          if (this.type == 4) {
            this.form.fit = this.form.fit.toString();
          }

          this.form.paper_id = id;
          if (this.form.chapter_id && this.chapter) {
            this.chapter.forEach((item) => {
              if (item.children) {
                item.children.forEach((ch) => {
                  if (ch.id == this.form.chapter_id) {
                    this.form.chapter_id = [item.id, this.form.chapter_id];
                    return;
                  }
                });
              }
            });
          } else {
            this.form.chapter_id = [];
          }
        }
        this.$http
          .get(process.env.VUE_APP_URL + "chapter")
          .then(function (data) {
            if (data.data.code == 200) {
              let chapter = data.data.data;
              let arr = [];
              if (chapter) {
                chapter.forEach((item) => {
                  let obj = {
                    label: item.name,
                    value: item.id,
                    children: [],
                  };
                  if (item.children) {
                    item.children.forEach((ch) => {
                      obj.children.push({
                        value: ch.id,
                        label: ch.name,
                      });
                    });
                  }
                  arr.push(obj);
                });
                _this.chapter = arr;
              }
            } else {
              _this.$message.error(data.data.msg);
            }
          })
          .catch(function (error) {
            _this.$message.error({ message: "网络错误,请刷新界面重试" });
            return;
          });
      },
      beforeUpload(file) {
        let _this = this;
        const isJPG = file.type == "image/jpeg";
        const isLt2M = file.size / 1024 / 1024 < 15;

        if (file.type == "image/jpeg") {
          _this.ext = "jpeg";
        }
        if (file.type == "image/jpg") {
          _this.ext = "jpg";
        }
        if (file.type == "image/png") {
          _this.ext = "png";
        }

        if (
          !file.type == "image/jpg" ||
          !file.type == "image/jpeg" ||
          !file.type == "image/png"
        ) {
          this.$message.error("上传图片只能是 JPG、PNG、JPEG 格式!");
        }
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 15MB!");
        }
        _this.fullscreenLoading = true;
        //let _this = this;

        let observer = {
          next(res) {
            _this.percent = parseInt(res.total.percent);
          },
          error(err) {
            //  console.log(err)
          },
          complete(res) {
            _this.imageUrl =
              "https://resource.edc.org.cn/" +
              res.key +
              "?imageMogr2/thumbnail/200x200";

            let quill = _this.$refs.myQuillEditor.quill;
            // 如果上传成功
            // 获取光标所在位置
            let length = quill.getSelection().index;
            // 插入图片  res.info为服务器返回的图片地址
            quill.insertEmbed(length, "image", _this.imageUrl);
            // 调整光标到最后
            quill.setSelection(length + 1);
          },
        };
        let time = new Date().getTime();
        _this.key = "KsNetban/" + time;
        let key = _this.key + "." + _this.ext;
        let observable = qiniu.upload(
          file,
          key,
          _this.token,
          _this.CoverputExtra,
          _this.config
        );
        let subscription = observable.subscribe(observer); // 上传开始
      },
      uploadSuccess(res, file) {
        let _this = this;
        let imageUrl = _this.imageUrl;
      },
      choseType(val) {
        this.optionIndex = null;
        this.type = val;
        this.addQuestion = true;
        this.ques = null;
      },
      onSubmit() {
        console.log(this.form);
        //处理数据(选项中的is_right)
        let cont = true; //选项内容是否添加
        this.form.options.forEach((option, index) => {
          if (this.type == 1 || this.type == 3) {
            if (this.form.is_right == index) {
              option.is_right = true;
            } else {
              option.is_right = false;
            }
          }
          if (this.type == 4) {
            this.form.is_right = true;
            option.is_right = 1;
          }
          if (option.name == "") {
            cont = false;
            return;
          }
        });
        if (this.form.chapter_id.length > 1) {
          this.form.chapter_id = this.form.chapter_id[1];
        } else {
          this.form.chapter_id = "";
        }
        if (this.form.is_bank) {
          this.form.is_bank = 1;
        } else {
          this.form.is_bank = 0;
        }
        if (this.form.is_insert) {
          this.form.is_insert = 1;
        } else {
          this.form.is_insert = 0;
        }
        this.form.is_sync ? (this.form.is_sync = 1) : (this.form.is_sync = 0); //导入题库
        if (this.form.name == "") {
          this.$message("请输入题干！");
          return;
        } else if (this.form.options.length <= 1 && this.type != 4) {
          this.$message("每道题至少需要两个或两个以上选项哦");
          return;
        } else if (!cont) {
          this.$message("选项内容不能为空！");
          return;
        } else if (this.form.is_right == null || this.form.is_right.length == 0) {
          this.$message("请设置正确选项！");
          return;
        } else if (this.type == 4 && !this.form.fit) {
          this.$message("请选择匹配方式！");
          return;
        } else {
          this.$emit("saveQuestion", this.form);
          this.init();
        }
      },
      removeOption(index) {
        //删除选项
        if (this.type == 2) {
          //当是多选题时，将form的is_right数组中对应的数据删除
          let i = this.form.is_right.indexOf(index);
          if (i != -1) {
            this.form.is_right.splice(i, 1);
          }
        } else {
          //单选的情况下直接将is_right置为null
          if (this.form.is_right == index) {
            this.form.is_right = null;
          }
        }
        this.form.options.splice(index, 1); //在选项数组中删除
      },
      addOption() {
        this.form.options.push({
          name: "",
          brief: "",
          is_right: false,
        });
        this.optionIndex = this.form.options.length - 1;
      },
      setDesc(data) {
        this.showDesc = true;
        this.brief = data.brief;
      },
      fun(val, option) {
        //改变选项的is_right
        option.is_right = val;
      },
      handleChange(val) { },
      handleSync(val) {
        this.form.is_sync = val;
        if (val && this.form.is_insert) {
          this.form.is_sync = false;
        }
      },
      handleInsert(val) {
        this.form.is_insert = val;
        if (val && this.form.is_sync) {
          this.form.is_insert = false;
        }
      },
    },
  };
</script>
<style lang="less" scoped>
  .addquestion {
    // font-weight: bolder;
    background-color: #fafafa;
    padding: 20px;
    font-size: 14px;
    color: #606266;

    .el-row {
      padding: 5px;
    }

    .addOption {
      color: #1989fa;
    }
  }

  .submint-btn {
    text-align: center;
  }

  .item_option {
    text-indent: 2em;
    font-style: normal;
  }

  img {
    width: 100px !important;
  }

  .queTitle {
    // display: flex;
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 5px;
  }

  .el-col-4 {
    text-align: center;
  }

  .addOption span,
  .addOption i {
    cursor: pointer;
  }

  .quill-editor {
    /deep/ .ql-container.ql-snow {
      background-color: #fff !important;
      height: 100px !important;
    }
  }

  .active {
    background: #409eff;
    color: #fff;
  }

  .el-radio {
    margin-right: 20px !important;
  }

  .editorUploader {
    display: none;
  }
</style>
<style>
  .quill-editor img {
    vertical-align: middle;
  }
</style>